import { render } from "./OurAdvantages.vue?vue&type=template&id=38ec3941&scoped=true"
import script from "./OurAdvantages.vue?vue&type=script&lang=js"
export * from "./OurAdvantages.vue?vue&type=script&lang=js"

import "./OurAdvantages.vue?vue&type=style&index=0&id=38ec3941&scoped=true&lang=css"

import exportComponent from "/Users/edvinasjuck/PhpstormProjects/arunvilkasa.lt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38ec3941"]])

export default __exports__